import { Caption } from '@cian/ui-kit';

import { type FC, type MouseEvent as ReactMouseEvent } from 'react';

import styles from './styles.css';

interface IGetOnlineButtonProps {
  href: string;
  onClick?(event: ReactMouseEvent<HTMLAnchorElement>): void;
}

export const GetOnlineButton: FC<IGetOnlineButtonProps> = ({ href, onClick }) => {
  return (
    <a
      className={styles['container']}
      data-testid="GetOnlineButton"
      href={href}
      rel="noreferrer"
      target="_blank"
      onClick={onClick}
    >
      <Caption>Получить онлайн</Caption>
    </a>
  );
};
